import React, { useEffect,useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Redirect,useHistory, useLocation } from "react-router-dom";

import { Articulo } from "../../components/FAQPage/faq";
import {
  FAQListContainer,
  Input,
  NuevaSolicitudBtn,
  SearchBar,
  SearchBarDiv,
} from "../../components/FAQPage/faqElements";
import { CreateRequest } from "../../components/svg/CreateRequest";
import { LupaBuscar } from "../../components/svg/LupaBuscar";
import {
  cleanStore,
  faq,
  getFaq,
  searchFaq,
  setCurrentPageFaqData,
  setRowsPerPage,
} from "../../store/modules/FaqStore";
import { PaginationComponent } from "../Request/Pagination";
import Footer from '../../components/layout/Footer';
import { getSelfServiceConfiguration,getParameter } from "../../store/modules/RequestStore";
import { RootState } from "../../store/store";
import { useTranslation as usei18n } from "react-i18next";

function useQuery() {
  const location = useLocation();
  return useMemo(() => new URLSearchParams(location.search), [location.search]);
}

const ListFaq = () => {
const history = useHistory();
  const dispatch = useDispatch();
  const faqState = useSelector((state: RootState) => state.faq);
  let query = useQuery();
  const { t } = usei18n();

  // const { translateText } = useTranslation();

  const [seeAll] = useState(false);
  const [redirect, setRedirect] = useState("");
  const [page, setPage] = useState(1);
  const [activoBtn, setActivoBtn] = useState(false);
  const rowsPerPage = useSelector((state: RootState) => state.faq.rowsPerPage || 10); 
  

  useEffect(() => {
    dispatch(getFaq(page, rowsPerPage));
  }, [dispatch, page, rowsPerPage]);

  const [isSearching, setIsSearching] = useState(false);

  // Carga inicial de FAQ si no está buscando
  useEffect(() => {
    if (!isSearching) {
      dispatch(getFaq(page, rowsPerPage));
    }
  }, [dispatch, page, rowsPerPage, isSearching]);

 useEffect(() => {
        const fetchParameter = async () => {
          const paramShowLang = await getParameter({ parameterName: "BotonCrearSolicitud" });
          if (
            paramShowLang?.data?.status === "Ok" &&
            paramShowLang.data.values.parameterValue.toString() === "1"
          ) {
            setActivoBtn(true);
          } 
        };
    
        fetchParameter();
      }, []);
  // useEffect(() => {
  //   const term = query.get("search");
  //   if (term) {
  //     dispatch(searchFaq(term));
  //   }
  // }, [dispatch, query]);

    useEffect(() => {
    return () => {
      dispatch(setRowsPerPage(10));
    };
  }, []);

  const handlePages = (newPage: any) => {
    setPage(newPage);
    dispatch(getFaq(newPage, rowsPerPage));
  };

  const search = (e: any) => {
      e.preventDefault();

    const term = e.target.search.value.trim();
    if (!term) return;

    setPage(1);
    setRedirect(term);
    setIsSearching(true);
    dispatch(searchFaq(term, 1, false));
  };
  const location = useLocation();
   const handleClearSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === "") {
    setRedirect("");
    setIsSearching(false);
    setPage(1);

  const params = new URLSearchParams(location.search);
  params.delete("search");
  history.replace({ search: params.toString() });
    dispatch(getFaq(1, rowsPerPage));
    }
  };
  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setRowsPerPage(newRowsPerPage);
  };

  return (
    <div>
      {seeAll ? <Redirect to="/faq/all" /> : null}
      {redirect !== "" ? (
        <Redirect
          to={{ pathname: "/faq/all", search: `?search=${redirect}` }}
        />
      ) : null}
      <Link to={"/"}>
        <svg
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 17L6 12M6 12L11 7M6 12L18 12"
            stroke="#111827"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Link>
      <SearchBarDiv>
        <SearchBar onSubmit={(e: any) => search(e)}>
          <Input
            type="search"
            name="search"
            onChange={handleClearSearch}
            placeholder={t("faq.inputSearch")}
          />
          <button
            type="submit"
            className="absolute right-0 top-3 mr-4 focus:outline-none"
          >
            <LupaBuscar />
          </button>
        </SearchBar>
      </SearchBarDiv>

      <div className="flex flex-col font-semibold my-4">
        <h1 className="text-xl text-green-600">{t("faq.title")}</h1>
        <p className="text-black">{t("faq.desc")}</p>
      </div>
      <FAQListContainer>
        {faqState.pageData.map((faq, index) => (
          <Articulo faq={faq} key={index} />
        ))}
        {
          activoBtn &&(<div className="flex flex-col items-center justify-center w-full h-16 my-10 gap-2 ">
          <p className="font-semibold">{t("faq.needHelp")}</p>
          <NuevaSolicitudBtn to="/request/new">
            {t("faq.linkCreateNewApplication")}
            <span className="ml-2">
              <CreateRequest size={`32`} />
            </span>
          </NuevaSolicitudBtn>
        </div>)
        }
        
        <div className="flex items-center justify-center my-4">
          <PaginationComponent
            page={page}
            totalPages={faqState.pagesTotal}
            handlePagination={handlePages}
            rowsPerPage={rowsPerPage}
            storeType="faq"
          />
        </div>
      </FAQListContainer>
      {/* <Footer /> */}
    </div>
  );
};

export default ListFaq;
